/**
 * Reducers are the pure functions (no side effects!) that update the store. Each reducer updates it's part of the (single) store.
 * Each reducer contains properties and exposes a pure function that will update the relevant part of the store.
 * Combines all the reducers so they can be exposed as one data structure.
 *
 */
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import currencyCodes from './currency-codes'
import fees from './fees'
import loading from './loading'
import countries from './countries'
import contacts from './contacts'
import errors from './errors'
import transactions from './transactions'
import user from './user'
import userActions from './user-actions'
import flowModel from './flow-model'
import { ActionTypes as types } from '../constants'
import { createBrowserHistory } from 'history'
const history = createBrowserHistory()

const appReducer = combineReducers({
  router: connectRouter(history),
  errors,
  countries,
  contacts,
  currencyCodes,
  fees,
  loading,
  transactions,
  user,
  userActions,
  flowModel,
})

const rootReducer = (state, action) => {
  if (action.type === types.RESET_TO_INITIAL) {
    state = undefined
  }
  return appReducer(state, action)
}

export default rootReducer
